// Module
var code = " <h2>Assignment 8 description</h2> <p>Submit:</p> <ol> <li>Your code</li> <li>Video link to your application</li> </ol>";
// Exports
export default code;